import { h, initializeWidgetConfiguration, SgWidget } from '@sgwt-widget/core';
import { ComponentProps, emit, props } from 'skatejs';
import { ISgwtSplashScreenProps } from './sgwt-splash-screen.types';
import SplashScreen from './components/SplashScreen';
import WidgetTracker from '../common/WidgetTracker';
import * as css from './sgwt-splash-screen.less';

export class SgwtSplashScreen extends SgWidget<ISgwtSplashScreenProps> {
  public static is = 'sgwt-splash-screen';
  private mode = 'active';
  private visible = false;

  public static props: ComponentProps<SgwtSplashScreen, ISgwtSplashScreenProps> = {
    application: props.string,
    mode: props.string,
    visible: props.boolean,
    manualActivation: props.boolean,
    sgConnectSupport: props.string,
    debug: props.boolean
  };

  constructor() {
    super();
  }

  show() {
    this.logDebug('show()');
    this.mode = 'active';
    this.visible = true;
  }

  showHistory() {
    this.logDebug('showHistory()');
    this.mode = 'history';
    this.visible = true;
  }

  onShow() {
    this.visible = true;
    this.emitEvent('show');
  }

  // Called when the modal has been asked to be displayed but not displayed, for example if no screen to display.
  onNotShown() {
    this.visible = false;
  }

  onHide() {
    this.visible = false;
    this.emitEvent('hide');
  }

  connectedCallback() {
    super.connectedCallback();
    this.logDebug('component ready');
    this.emitEvent('ready');
  }

  private logDebug(...messages: any[]) {
    if (this.props.debug) {
      console.log('[sgwt-splash-screen::debug]', ...messages);
    }
  }

  private emitEvent(name: string, detail: object = {}) {
    emit(this, `${SgwtSplashScreen.is}--${name}`, {detail});
    this.logDebug(`emit event "${SgwtSplashScreen.is}--${name}"`, detail);
  }

  renderCallback() {
    if (!this.props.application) {
      return <span/>;
    }
    return (
      <span>
        <style>{(css as any).toString()}</style>
        <SplashScreen
          mode={this.mode}
          sgConnectSupport={this.props.sgConnectSupport}
          visible={this.visible}
          application={this.props.application}
          onShow={() => this.onShow()}
          onHide={() => this.onHide()}
          onNotShown={() => this.onNotShown()}
          manualActivation={this.props.manualActivation}
          debug={this.props.debug}
        />
        <WidgetTracker widgetName={SgwtSplashScreen.is}/>
      </span>
    );
  }
}


initializeWidgetConfiguration(SgwtSplashScreen, {
  disablejQuerySanityCheck: true,
  neverUseShadowDOM: true
});
customElements.define(SgwtSplashScreen.is, SgwtSplashScreen);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/sgwt-splash-screen/sgwt-splash-screen.tsx